import React from "react";
import { Button } from "./Button";
import { Select } from "./Select";
import { Radio } from "./Radio";
import { Checkbox } from "./Checkbox";
import { Input } from "./Input";

export class Meldung extends React.PureComponent {
    render() {
        const styleTable = { borderCollapse: "collapse", width: "*", height: "*", tableLayout: "fixed" };
        const styleTd1 = { width: 140 };
        const styleTd2 = { width: "*" };
        let showJahrgang = false;
        let showKlasse = false;
        let showKlassenstaerke = false;
        let showKurs = false;
        let showSchuelerVermisst = false;
        let showSchuelerRaum = false;
        if (this.props.meldung.unterricht) {
            showJahrgang = true;
            if (this.props.meldung.jahrgang === " 5" || this.props.meldung.jahrgang === " 6" || this.props.meldung.jahrgang === " 7" || this.props.meldung.jahrgang === " 8" || this.props.meldung.jahrgang === " 9" || this.props.meldung.jahrgang === "10" || this.props.meldung.jahrgang === "VK") {
                showKlasse = true;
            };
            if (showKlasse && this.props.meldung.klasse !== "x") {
                showKlassenstaerke = true;
            };
            if (!showKlasse || !showKlassenstaerke || (showKlassenstaerke && !this.props.meldung.klassenstaerke)) {
                showKurs = true;
            };
            showSchuelerVermisst = true;
            if (this.props.meldung.schuelerVermisst > 0) {
                showSchuelerRaum = true;
            };
        };
        let styleJahrgang;
        let styleKlasse;
        let styleKlassenstaerke;
        let styleKurs;
        let styleSchuelerVermisst;
        let styleSchuelerRaum;
        if (!showJahrgang) {
            styleJahrgang = { color: "transparent" };
        };
        if (!showKlasse) {
            styleKlasse = { color: "transparent" };
        };
        if (!showKlassenstaerke) {
            styleKlassenstaerke = { color: "transparent" };
        };
        if (!showKurs) {
            styleKurs = { color: "transparent" };
        };
        if (!showSchuelerVermisst) {
            styleSchuelerVermisst = { color: "transparent" };
        };
        if (!showSchuelerRaum) {
            styleSchuelerRaum = { color: "transparent" };
        };
        let jahrgangOptions = [" 5", " 6", " 7", " 8", " 9", "10", "EF", "Q1", "Q2", "VK", "X"];
        let jahrgangOptionsBeschriftung = [" 5", " 6", " 7", " 8", " 9", "10", "EF", "Q1", "Q2", "VK", "Kurs"];
        let klasseOptions = ["a", "b", "c", "d", "e", "x"];
        let klasseOptionsBeschriftung = ["a", "b", "c", "d", "e", "Kurs"];
        if (this.props.meldung.jahrgang === "VK") {
            klasseOptionsBeschriftung = ["01", "02", "03", "04", "05", "Kurs"];
        }
        return (
            <React.Fragment>
                <table style={styleTable}>
                    <tbody>
                        <tr>
                            <td colSpan="2"><h1><Button name={"Hauptmenü"} handleClick={this.props.handleClick} beschriftung={"Hauptmenü"} buttonDisabled={false} buttonVisible={true} buttonAppearance={true} buttonRot={false} minWidth={200} minHeight={50} margin={6} /></h1></td>
                        </tr>
                        <tr>
                            <td style={styleTd1}>Lehrer:</td><td style={styleTd2}><Select name={"Lehrer Wahl"} handleChange={this.props.handleChange} value={this.props.meldung.id} options={this.props.kollegium.map(lehrer => lehrer.id)} optionsBeschriftung={this.props.kollegium.map(lehrer => lehrer.nachname + ", " + lehrer.vorname)} selectDisabled={false} selectVisible={true} selectAppearance={true} textAlign="left" fontWeight="normal" color="black" minWidth={220} maxWidth={220} /></td>
                        </tr>
                        <tr>
                            <td>Standort:</td><td><Radio name={"Standort Wahl"} handleChange={this.props.handleChange} value={"true"} id={"1"} beschriftung={"Nikolausstr."} checked={this.props.meldung.standort} radioDisabled={false} radioVisible={true} />&nbsp;&nbsp;<Radio name={"Standort Wahl"} handleChange={this.props.handleChange} value={"false"} id={"2"} beschriftung={"Lotharstr."} checked={!this.props.meldung.standort} radioDisabled={false} radioVisible={true} /></td>
                        </tr>
                        <tr>
                            <td>Unterricht:</td><td><Checkbox name={"Unterricht Wahl"} handleChange={this.props.handleChange} checked={this.props.meldung.unterricht} checkboxDisabled={false} checkboxVisible={true} /></td>
                        </tr>
                        <tr>
                            <td style={styleJahrgang}>Jahrgang:</td><td><Select name={"Jahrgang Wahl"} handleChange={this.props.handleChange} value={this.props.meldung.jahrgang} options={jahrgangOptions} optionsBeschriftung={jahrgangOptionsBeschriftung} selectDisabled={false} selectVisible={showJahrgang} selectAppearance={true} textAlign="left" fontWeight="normal" color="black" minWidth={72} maxWidth={72} /></td>
                        </tr>
                        <tr>
                            <td style={styleKlasse}>Klasse:</td><td><Select name={"Klasse Wahl"} handleChange={this.props.handleChange} value={this.props.meldung.klasse} options={klasseOptions} optionsBeschriftung={klasseOptionsBeschriftung} selectDisabled={false} selectVisible={showKlasse} selectAppearance={true} textAlign="left" fontWeight="normal" color="black" minWidth={72} maxWidth={72} /></td>
                        </tr>
                        <tr>
                            <td style={styleKlassenstaerke}>Klassenstärke:</td><td><Checkbox name={"Klassenstärke Wahl"} handleChange={this.props.handleChange} checked={this.props.meldung.klassenstaerke} checkboxDisabled={false} checkboxVisible={showKlassenstaerke} /></td>
                        </tr>
                        <tr>
                            <td style={styleKurs}>Kursbezeichnung:</td><td><Input name={"Kurs Eingabe"} handleChange={this.props.handleChange} eingabewert={this.props.meldung.kurs} maxLength={12} inputDisabled={false} inputVisible={showKurs} inputAppearance={true} textAlign="left" fontWeight="normal" color="black" minWidth={96} maxWidth={96} /></td>
                        </tr>
                        <tr>
                            <td style={styleSchuelerVermisst}>Schüler (vermisst):</td><td><Select name={"Schüler Vermisst Wahl"} handleChange={this.props.handleChange} value={this.props.meldung.schuelerVermisst} options={[...Array(41).keys()].map(index => index.toString())} optionsBeschriftung={[...Array(41).keys()].map(index => index.toString())} selectDisabled={false} selectVisible={showSchuelerVermisst} selectAppearance={true} textAlign="left" fontWeight="normal" color="black" minWidth={44} maxWidth={44} /></td>
                        </tr>
                        <tr>
                            <td style={styleSchuelerRaum}>Zuletzt gesehen:</td><td><Input name={"Schüler Raum Eingabe"} handleChange={this.props.handleChange} eingabewert={this.props.meldung.schuelerRaum} maxLength={20} inputDisabled={false} inputVisible={showSchuelerRaum} inputAppearance={true} textAlign="left" fontWeight="normal" color="black" minWidth={96} maxWidth={96} /></td>
                        </tr>
                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><Button name={"Meldung Senden"} handleClick={this.props.handleClick} beschriftung={"Abschicken"} buttonDisabled={!this.props.alarm} buttonVisible={true} buttonAppearance={true} buttonRot={false} minWidth={200} minHeight={50} margin={6} /></td>
                        </tr>
                    </tbody>
                </table>
            </React.Fragment>
        );
    };
};